import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {
  Link,
  SrOnly,
  LinkIcon
} from '..'
import config from '../../config'
import Styles from './DonateBanner.css'

@CSSModules(Styles)
export default class DonateBanner extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    return (
      <div styleName='banner-wrap'>
        <div styleName='banner'>
          <div styleName='banner-inner'>
            <div styleName='banner-info'>
              <div styleName='banner-headline'>
                Your support keeps this working
              </div>
              <div styleName='banner-subtitle'>
                Make a gift today to support As You Sow, a 501c3 non-profit
              </div>
              <div styleName='banner-logo'>
                <Link to={config.links.ays} title='As You Sow'>
                  <div styleName='ays' title='As You Sow'/>
                  <SrOnly>As You Sow</SrOnly>
                </Link>
              </div>
            </div>
            <div styleName='banner-button'>
              <Link
                to={config.links.donate}
                donatebanner={true}
                title='Donate'
              >
                Donate<LinkIcon faclass='fa-heart' />
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

